import React, { useEffect, useRef } from "react";
import cn from "classnames";
import s from "./Modal.module.scss";
import IconClose from "public/img/icons/sprite/close.svg";
import { SpriteIcon } from "@/components/UI/SpriteIcon";

export type ModalProps = {
  children: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
  onClick?: () => void;
  className?: string;
};

export const Modal = ({ children, open, setOpen, onClick, className, onClose }: ModalProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleCLose = () => {
    setOpen(false);
    onClose?.();
  };

  const onOverlayClick = (event: React.MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest("." + s.modal)) handleCLose();
    onClick?.();
  };

  useEffect(() => {
    if (open) {
      document.documentElement.classList.add("overflow-hidden");
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("overflow-hidden");
    };
  }, [open]);

  return open ? (
    <div className={s.overlay} ref={overlayRef} onClick={onOverlayClick}>
      <div className={s.wrapper}>
        <div className={s.inner}>
          <div className={cn(s.modal, className)}>
            {children}
            <button type="button" className={s.closeBtn} onClick={handleCLose}>
              <SpriteIcon icon={IconClose} />
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
